import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import { apiClient } from '@services/apiClient';

import type { ISensorListEquipment } from '../model/sensorListEquipment';

export const equipmentsViewKey = (equipmentId?: string) => ['equipmentsView', equipmentId];
export const equipmentsViewFn = ({ queryKey }: QueryFunctionContext<string[]>) =>
  apiClient.get(`${APP_API_URL}equipments/view/${queryKey[1]}`);

const equipmentsViewSelect = ({ data }: AxiosResponse<{ equipment: ISensorListEquipment }>) => data;

export const useEquipmentsViewQuery = ({ equipmentId }: { equipmentId?: string }) => {
  return useQuery({
    // @ts-ignore TODO: update react-query to v5
    queryKey: equipmentsViewKey(equipmentId),
    queryFn: equipmentsViewFn,
    select: equipmentsViewSelect,
    placeholderData: {
      data: {
        equipment: {},
      },
    },
  });
};
